import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Pages from '@/pages';

function RouterContainer() {
  return (
      <Routes>
          <Route
            path="/"
            element={
                <Pages.Login />
            }
          />
      </Routes>
  );
}

export default RouterContainer;
